import { Box, IconButton, Stack } from "@mui/material";
import CustomTable from "components/reusable/customTable/CustomTable";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { apiReq } from "services/Requests";
import { API_BASE_URL, API_ROUTES } from "utils/apiRoutes.constant";
import edit from "assets/client/edit.png";
import dayjs from "dayjs";
import detail from "assets/client/detail.png";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import Signature from "components/modals/Signature";
import ValidateTaxModal from "components/modals/ValidateTaxModal";
import FormationPreviewModal from "components/modals/FormationPreviewModal";
import WorksheetModal from "components/modals/WorksheetModal";
import { WorkSheetContainer } from "pages/client/workSheet/WorkSheet";
import { HeadingFive } from "components/reusable/typography/Typography.style";
import { TitleButton } from "components/reusable/titleComponent/TitleComponent";
import NonProfitPreview from "components/modals/NonProfitPreview";

const errorToast = (message = "") => toast.error(message);
const infoToast = (message = "") => toast.info(message);
const NonProfitFormationList = () => {
  const [tab_loader, setTabLoader] = useState(true);
  const [businessData, setBusinessData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isPreviewModal, setIsPreviewModal] = useState(false);
  const [modalData, setModalData] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const [businessIds, setBusinessIds] = useState();
  const [isTermModal, setIsTermModal] = useState(false);

  const clientId = localStorage.getItem("clientId");

  const BGColumns = [
    {
      headerName: "Sr#",
      field: "srNo",
      width: 80,
      editable: false,
    },

    {
      headerName: "Non Profit Name",
      field: "nonProfitFormationName",
      width: 300,
      editable: false,
    },

    {
      field: "noVendors",
      headerName: "No. of Members",
      width: 300,
      editable: false,
    },
    {
      field: "status",
      headerName: "Status",
      width: 300,
      editable: false,
      renderCell: (params) => (
        <div
          style={{
            backgroundColor:
              params.row.status === "Data Entery"
                ? "rgba(0, 173, 239, 0.16)"
                : "rgba(244, 184, 27, 0.3)",
            color: params.row.status === "Data Entery" ? "#0095CE" : "#D09600",
            borderRadius: "15px",
            padding: "5px 10px 5px 10px",
            fontSize: "12px",
          }}
        >
          {params.row.status}
        </div>
      ),
    },
    {
      field: "date",
      headerName: "Date",
      width: 300,
      editable: false,
      renderCell: (params) => (
        <div>{dayjs(params.values).format("DD-MM-YYYY")}</div> // Assuming you have a formattedDate function
      ),
    },
    {
      headerName: "Action",
      width: 100,
      sortable: false,
      editable: false,
      renderCell: (params) => (
        <Stack direction="row" justifyContent="space-around">
          {params.row.status !== "Submitted" && (
            <IconButton
              color="primary"
              onClick={() => {
                localStorage.setItem(
                  "nonProfitId",
                  JSON.stringify(params.row.otherDetails._id)
                );
                localStorage.setItem("nonProfitEdit", true);
                navigate("/add-nonProfit");
              }}
            >
              <img src={edit} alt="edit" width={30} height={25} />
            </IconButton>
          )}
          <IconButton
            color="primary"
            onClick={() => {
              setModalData(params.row.otherDetails);
              setIsPreviewModal(true);
            }}
          >
            <img src={detail} alt="detail" width={30} height={25} />
          </IconButton>
        </Stack>
      ),
    },
  ];

  const fetchData = async () => {
    try {
      setTabLoader(true);
      const response = await apiReq(API_ROUTES.getNonProfitList, "POST", {
        clientId,
      });
      const responseData = await response.data;

      // Extracting all _id values and setting them
      const businessIds = responseData?.data?.map(
        (businessFormation) => businessFormation?._id
      );
      setBusinessIds(businessIds); // Save the array of ids

      // Mapping the data for display
      const updatedData = responseData?.data?.map((businessFormation, i) => ({
        id: businessFormation?._id,
        srNo: i + 1,
        nonProfitFormationName: businessFormation?.basicInfo.nonProfitName,
        noVendors: businessFormation?.officersBoardTrustees?.length,
        status: businessFormation?.status,
        date: businessFormation?.createdAt,
        otherDetails: businessFormation,
      }));

      setBusinessData(updatedData);
    } catch (error) {
      errorToast(
        error?.message ||
          error?.response?.message ||
          "Error fetching data. Please try later."
      );
    } finally {
      setTabLoader(false);
    }
  };
  console.log(businessIds, "BusinessIds");
  const handleSaveSignature = async (signatureData) => {
    try {
      const clientId = localStorage.getItem("clientId");
      if (!clientId) {
        errorToast("clientId not found!");
        return;
      }
      setLoading(true);
      const formData = new FormData();
      formData.append("clientId", clientId);

      formData.append("nonProfitFormationIds", JSON.stringify(businessIds));
      formData.append("status", "Submitted");

      if (signatureData) {
        const { signatureFile, ...rest } = signatureData;
        formData.append("signatureData", JSON.stringify(rest));
        formData.append("signatureFile", signatureFile);
      }
      // Create API call
      await apiReq(
        API_ROUTES.SubmitNonProfitForms,
        "POST",
        formData,
        API_BASE_URL,
        false
      );

      // peronalCollectionId
      // generalBusinessId

      setTimeout(() => {
        infoToast("Form submitted successfully");
        setIsTermModal(false);
        fetchData();
      }, 2000);
    } catch (error) {
      errorToast(
        error?.message ||
          "An unexpected error occurred. Please try again later."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    localStorage.removeItem("nonProfitId");
    localStorage.removeItem("nonProfitEdit");
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <WorkSheetContainer>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <HeadingFive fontSize="20px" fontWeight="500">
            Non Profit Formation
          </HeadingFive>
          <Box sx={{ display: "flex", alignItems: "center", gap: "20px" }}>
            <TitleButton onClick={() => navigate("/add-nonProfit")}>
              Add New Non-Profit
            </TitleButton>
            <TitleButton onClick={() => setIsTermModal(true)}>
              Submit All Docs
            </TitleButton>
          </Box>
        </Box>
        <BusinessListWrapper>
          <CustomTable
            loading={tab_loader}
            rows={businessData}
            columns={BGColumns}
          />
        </BusinessListWrapper>
        <Signature
          loading={loading}
          isModalOpen={isTermModal}
          onSaveSignature={handleSaveSignature}
          closeModal={() => setIsTermModal(!isTermModal)}
        />
        <NonProfitPreview
          isModalOpen={isPreviewModal}
          closeModal={() => setIsPreviewModal(!isPreviewModal)}
          modalData={modalData}
        />
      </WorkSheetContainer>
    </>
  );
};

export default NonProfitFormationList;

const BusinessListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-gap: 50px;
`;
